import { isBrowser } from '../utils/utils';
export function forceVariation({ flagDTO, config }) {
    if (!config.isQAModeEnabled || !isBrowser() || !flagDTO || !window?.flagship?.forcedVariations) {
        return undefined;
    }
    const forcedVariation = window.flagship.forcedVariations[flagDTO.campaignId];
    if (!forcedVariation) {
        return undefined;
    }
    const { campaignId, campaignName, variationGroupId, variationGroupName, campaignType, CampaignSlug, variation } = forcedVariation;
    const value = variation.modifications.value[flagDTO.key];
    return {
        key: flagDTO.key,
        campaignId,
        campaignName,
        variationGroupId,
        variationGroupName: variationGroupName,
        variationId: variation.id,
        variationName: variation.name,
        isReference: !!variation.reference,
        campaignType,
        slug: CampaignSlug,
        value
    };
}
